(function(){
function enhance(track){
  if(track.dataset.ibsl)return; track.dataset.ibsl='1';
  var wrap=document.createElement('div'); wrap.className='ibsl-wrap';
  track.parentNode.insertBefore(wrap,track); wrap.appendChild(track);
  var ctrl=document.createElement('div'); ctrl.className='ibsl-ctrl';
  var prev=document.createElement('button'); prev.type='button'; prev.className='ibsl-arrow ibsl-prev'; prev.setAttribute('aria-label','Previous'); prev.innerHTML='&#8249;';
  var dots=document.createElement('div'); dots.className='ibsl-dots';
  var next=document.createElement('button'); next.type='button'; next.className='ibsl-arrow ibsl-next'; next.setAttribute('aria-label','Next'); next.innerHTML='&#8250;';
  ctrl.appendChild(prev); ctrl.appendChild(dots); ctrl.appendChild(next); wrap.appendChild(ctrl);
  var cards=track.children;
  function step(){ return cards[0]? cards[0].getBoundingClientRect().width+14 : 300; }
  for(var i=0;i<cards.length;i++){ var d=document.createElement('button'); d.type='button'; d.className='ibsl-dot'; d.setAttribute('aria-label','Slide '+(i+1));
    (function(idx){ d.addEventListener('click',function(){ track.scrollTo({left:idx*step(),behavior:'smooth'}); }); })(i); dots.appendChild(d); }
  prev.addEventListener('click',function(){ track.scrollBy({left:-step(),behavior:'smooth'}); });
  next.addEventListener('click',function(){ track.scrollBy({left:step(),behavior:'smooth'}); });
  var raf;
  function update(){ var i=Math.round(track.scrollLeft/step()); var ds=dots.children;
    for(var j=0;j<ds.length;j++){ ds[j].className='ibsl-dot'+(j===i?' on':''); }
    prev.disabled=track.scrollLeft<=2; next.disabled=track.scrollLeft>=track.scrollWidth-track.clientWidth-2; }
  track.addEventListener('scroll',function(){ if(raf)cancelAnimationFrame(raf); raf=requestAnimationFrame(update); },{passive:true});
  update();
}
function init(){ document.querySelectorAll('.ibsl').forEach(enhance); }
if(document.readyState!=='loading')init(); else document.addEventListener('DOMContentLoaded',init);
})();